<template>
    <UIGridContainer>
        <UIGridRow>
            <UIGridCol cols="12" md="8" class="mx-auto">
                <UITabs
                    class="mt-4 mb-5"
                    :tabs="[0, 1]"
                    :initial-tab="$route.query.history ? 1 : 0"
                    @tab-changed="tabChanged"
                >
                    <template slot="tab-head-0">
                        {{ translate('contact.title') }}
                    </template>
                    <template slot="tab-body-0">
                        <ServiceContactForm :notifications="notifications" />
                    </template>

                    <template slot="tab-head-1">
                        {{ translate('contact.order.title') }}
                    </template>
                    <template slot="tab-body-1">
                        <OrderHistoryForm />
                    </template>
                </UITabs>
                <AppOccasionReturn v-if="supportsPromotion('app') && tabIndex == 1" class="mt-1"></AppOccasionReturn>
            </UIGridCol>
        </UIGridRow>
    </UIGridContainer>
</template>

<script>
import { UIGridCol, UIGridRow, UIGridContainer, UITabs } from '@dundle/ui/components';
import OrderHistoryForm from '~/components/order/OrderHistoryForm';
import ServiceContactForm from '~/components/service/ServiceContactForm';
import TranslationMixin from '~/mixins/TranslationMixin';
import PageMixin from '~/mixins/PageMixin';
import MarketingMixin from '~/mixins/MarketingMixin';
import { AppOccasionReturn } from '~/components/occasion';

export default {
    name: 'ContactPage',

    components: {
        UIGridCol,
        UIGridRow,
        UIGridContainer,
        UITabs,
        ServiceContactForm,
        OrderHistoryForm,
        AppOccasionReturn,
    },

    mixins: [TranslationMixin, PageMixin, MarketingMixin],
    async asyncData({ app, route }) {
        const pageData = await PageMixin.fetchData({ app, route });
        const notifications = await app.$api.notifications.getNotifications();
        return {
            ...pageData,
            notifications,
        };
    },

    data() {
        return {
            tabIndex: this.$route.query.history ? 1 : 0,
            linkToApp: '',
        };
    },
    mounted() {
        this.$gtm?.push({ event: `page_view_contact` });

        if (this.$device.isIOS()) {
            this.linkToApp = 'https://apps.apple.com/app/dundle-prepaid-cards-egifts/id1605958640';
        } else {
            this.linkToApp =
                'https://play.google.com/store/apps/details?id=com.dundle.app&referrer=utm_source%3Dwebsite%26utm_medium%3Dhistory_page%26utm_term%3Dapp_campaign%26anid%3Dadmob';
        }
    },

    methods: {
        tabChanged(index) {
            this.tabIndex = index;
        },
        navigateToApp() {
            window.open(this.linkToApp, '_blank');
        },
    },

    httpCaching: {
        maxAge: 60 * 30,
    },

    pageCaching: {
        maxAge: 60 * 30,
    },
};
</script>

<style lang="scss" scoped>
.service-links {
    margin-top: 5rem;
}
.banner-img {
    border-radius: 0.4rem;
}
</style>
<i18n src="@dundle/locale/data/contact.json"></i18n>
